var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "center", height: "200px" } },
        [
          _c(
            "el-form",
            [
              _c("br"),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("span", [_vm._v(_vm._s(_vm.$t("Menu.StandardLibrary2")))]),
              _c("br"),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "center",
                    [
                      _c("cargo-advance-select", {
                        ref: "tenantSel",
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type": _vm.selectTypeNames.TENANT,
                          cache: false,
                          filterable: "",
                          "custom-label": _vm.companyLabel,
                          "callback-params": { key: "relateTenantId" },
                          "callback-method-type": "value",
                          "default-value": _vm.cboTenantId
                            ? _vm.cboTenantId
                            : "",
                          "static-options": _vm.standardList
                        },
                        on: { parentCallBack: _vm.tenantIdChangeHandler }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveBasicHandler } },
            [_vm._v(_vm._s(_vm.$t("Menu.Start")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("Menu.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }